module.exports = __webpack_public_path__ + "static/media/YF38_3.425b8564.jpg";